import { observer } from 'mobx-react-lite'
import React from 'react'
import { Label } from 'shared/ui'
import { type ITagSelectProps } from 'entities/Tags'
import { RinglessMessageField } from 'widgets/MessageFormFields/RinglessMessageField'
import { type GreetingAudioBlockStore } from '../../store/GreetingAudioBlockStore'

type IGreetingAudioBlockEditContentProps = {
  store: GreetingAudioBlockStore
  labelText?: string
} & Partial<ITagSelectProps>

export const GreetingAudioBlockEditContent = observer(
  ({ store, labelText }: IGreetingAudioBlockEditContentProps) => {
    const { ringlessMessageFieldStore } = store
    return (
      <div>
        {labelText && <Label label={{ text: labelText }} marginBottom={4} />}
        <RinglessMessageField
          store={ringlessMessageFieldStore}
          border={'outlined'}
          dropdownWidth={350}
          showAudioDeliveryInfo={false}
        />
      </div>
    )
  }
)
